class AlertController {
    constructor() {
        this.currentAlert = undefined
        this.alerts = {}
        this.resolve = undefined
    }

    async runCheckLogics() {
        return new Promise( (resolve, ) => {
            let keys = Object.keys(this.alerts) ?? []
            if (keys.length == 0) { resolve(true); return }
            for (let i=0 ; i<keys.length ; i++) {
                let key = keys[i]
                let currentAlert = this.alerts[key]?.alert
                let result = currentAlert?.checksum()
                if (result == false) {
                    let comp = currentAlert.component
                    let alertKey = key.replace(comp._uid, '')
                    comp.$nextTick( async () => {
                        let alertResult = await this.showAlert(comp, alertKey)
                        if (alertResult == 'close') {
                            resolve(false)
                            return
                        }
                        resolve(true)
                        return
                    })
                }
                else {
                    resolve(true)
                    return
                }
            }
        })
    }

    //MARK: - Public
    /*
     *  key : String,
     *  alert : {
     *      usingCloseButton: Boolean,
     *      usingAlertTag: Boolean,
     *      text: String,
     *      lButtonTitle: String,
     *      rButtonTitle: String
     *      checksum: function,
     *      cHandler: function,
     *      lHandler: function,
     *      rHandler: function
     *  }
     */
    registAlert(component, key, alert) {
        let uniqueKey = component._uid + key
        alert.component = component
        this.alerts[uniqueKey] = {
            alert: alert
        }
    }
    
    unregistAlert(component, key) {
        let uniqueKey = component._uid + key
        delete this.alerts[uniqueKey]
    }

    async showAlert(component, key) {
        if (this.currentAlert != undefined) { return }
        let uniqueKey = component._uid + key
        return new Promise( (resolve) => {
            this.currentAlert = this.alerts[uniqueKey]
            this.resolve = resolve
        })
    }

    hideAlert() {
        this.resolve = undefined
        this.currentAlert = undefined
    }
}

const AC = new AlertController()
export default AC